/* global $:false, Handlebars:false, Typekit:false, alert:false, config:false, document:false, Course:false, LOADER:false */
"use strict";

var Deploy = (function() {
	var publicAPI = {},
		deployConfig,
		scripts = [ // broken down into groups to make sure depencies don't break
			// baseline dependency for everything else
			[{
				src: "jquery.min.js",
				id: "jquery"
			}, {
				src: "spin.js",
				id: "spin"
			}, {
				src: "core.js",
				id: "core"
			}],
			// classes we need but that don't do anything independently
			[{
				src: "handlebars-v4.0.5.js",
				id: "handlebars"
			}, {
				src: "loader.js",
				id: "loader"
			}, {
				src: "browserCompatibility.js",
				id: "browserCompatibility"
			}, {
				src: "lzstring.js",
				id: "lzstring"
			}, {
				src: "bootstrap.min.js",
				id: "bootstrap"
			}, {
				src: "UnityProgress.js",
				id: "UnityProgress"
			}],			
			[{
				src: "NoSleep.js",
				id: "NoSleep"
			}],
			// fire up the sim
			[{
				src: "course.js",
				id: "course"
			}],
			// scripts with dependencies on Course
			[{
				src: "lms.js",
				id: "lms"
			}, {
				src: "debug.js",
				id: "debug"
			}]
		],
		scriptGroup = 0,
		queuedScripts = 0,
		loadedScripts = 0,
		bodyHTML;

	publicAPI.load = function(config) {
		// there are a few special case scripts that we don't host, so add those manually
		appendScript("https://use.typekit.net/qwq1ldq.js", "typekit");

		deployConfig = config;
		addScripts(scripts[scriptGroup]);
	};

	publicAPI.getConfig = function() {
		return deployConfig;
	};

	publicAPI.getWrapperURL = function() {
		return deployConfig.wrapperURL;
	};

	publicAPI.getBody = function() {
		return bodyHTML;
	};


	// Private Methods
	function addScripts(scriptList) {
		queuedScripts = scriptList.length;
		loadedScripts = 0;

		for (var i = scriptList.length - 1; i >= 0; i--) {
			var scriptURL = deployConfig.wrapperURL + "/js/" + scriptList[i].src,
				scriptID = scriptList[i].id;

			appendScript(scriptURL, scriptID);
		}

	}

	// http://stackoverflow.com/questions/6806584/object-onload-in-internet-explorer-6-7-and-8
	function appendScript(url, id) {
		var head = document.getElementsByTagName('head')[0];
		var script = document.createElement('script');

		script.type = 'text/javascript';
		script.onload = onScriptLoaded;
		script.src = url;
		script.id = id;
		script.onreadystatechange = function() {
			if (this.readyState == "loaded") {
				onScriptLoaded(script);
			}
		};

		head.appendChild(script);
	}

	function onScriptLoaded(s) {
		var scriptID = null;

		try {
			scriptID = s.target.id;
		} catch (e) {
			scriptID = s.id;
		}

		switch (scriptID) {
			case "jquery":
				// load all the things that need to go into the body first
				$.ajax({
						url: deployConfig.wrapperURL + "/includes/deploy/body.html",
						type: "get",
						async: true,
						dataType: "html"
					})
					.fail(function(data) {
						alert(data.statusText);
					})
					.done(function(html) {
						bodyHTML = html;
						$("body").append(html);
					});

				break;
			case "typekit":
				try {
					Typekit.load({
						async: true
					});
				} catch (e) {}

				break;
			case "handlebars":
				// load css & non-script tag items for the head
				$.ajax({
						url: deployConfig.wrapperURL + "/includes/deploy/head.html",
						type: "get",
						async: true,
						dataType: "html"
					})
					.fail(function(data) {
						alert(data.statusText);
					})
					.done(function(html) {
						var template = Handlebars.compile(html),
							cssTemplate = template(deployConfig);
						$("head").append(cssTemplate);
					});

				break;
			case "loader":
				LOADER.fadeIn();
				break;

		}

		var isGroupLoaded = true; // then flip to false if we find a non-loaded id
		if (scripts.length > scriptGroup) {
			for (var i = 0; i < scripts[scriptGroup].length; i++) {
				if (!scripts[scriptGroup][i].isLoaded) {

					if (scripts[scriptGroup][i].id == scriptID) {
						scripts[scriptGroup][i].isLoaded = true;
					} else {
						// if a script other than the current id isn't loaded then we haven't finished with the group
						isGroupLoaded = false;
					}

				}
			}

		}


		// move on to the next group
		if (isGroupLoaded) {
			scriptGroup++;
			if (scriptGroup < scripts.length) {
				addScripts(scripts[scriptGroup]);
			} else {
				// if every script is loaded then move on to actually starting the Sim
				Course.init();
			}
		}

	}

	return publicAPI;
})();

// config is defined on the loading page
Deploy.load(config);